import { DomainEvent } from '../../../../core/domain/events/domain_event';
import { News } from '../news';

export class NewsEvent extends DomainEvent<News> {}

export class NewsCreated extends NewsEvent {}

export class NewsUpdated extends NewsEvent {}

export class NewsDeleted extends NewsEvent {}
